<template>
  <div id="mainContainer" style="height: 100%">
    <a-layout>
      <a-layout-header :style="{ zIndex: 99, width: '100%'}"
                       style="background: transparent; padding: 0; height: 46px;" class="mainHeader">
        <img src="./assets/logoRH2.png" alt="" class="headerLogo">
        <div class="menu-container" :style="headerBg">
          <div class="menu">
            <img :src="profileSrc" class="mobile only" alt=""
                 style="max-height: 40px; float: right; right: 46px; position: relative; top: 10px;">
            <a href="#" class="menu-mobile">&nbsp;</a>
            <ul>
              <template v-for="menu in userInfo.menu">
                <li v-if="menu.visible == true || menu.visible == 'true'">
                  <a :href="menu.path ? ('/#'+menu.path) : '#'" v-on:click.prevent="navigate(menu)">{{menu.name}}</a>
                  <ul v-if="menu.children && menu.children.length > 0">
                    <template v-for="submenu in menu.children">
                      <li>
                        <a :href="submenu.path ? ('/#'+submenu.path) : '#'" v-on:click.prevent="navigate(submenu)">{{submenu.name}}</a>
                        <ul v-if="submenu.children && submenu.children.length > 0">
                          <template v-for="subsubmenu in submenu.children">
                            <li>
                              <a :href="subsubmenu.path ? ('/#'+subsubmenu.path) : '#'"
                                 v-on:click.prevent="navigate(subsubmenu)">{{subsubmenu.name}}</a>
                            </li>
                          </template>
                        </ul>
                      </li>
                    </template>
                  </ul>
                </li>
              </template>
              <li style="float: right">
                <a href="#" style="padding: 4px 20px;">
                  <img :src="profileSrc" alt="" style="max-height: 40px">
                  {{userInfo.name}}
                </a>
                <ul class="optionsMenu">
                  <li>
                    <a href="#" @click.prevent="()=>{ cc.visible = true }">Cambiar Contraseña</a>
                  </li>
                  <li v-if="!this.$store.state.appSettings.loginOkta">
                    <a href="#" @click.prevent="logout">Cerrar Sesión</a>
                  </li>
                  <li v-if="this.$store.state.appSettings.loginOkta">
                    <a href="#" @click.prevent="logoutWithOkta">Cerrar Sesión</a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </a-layout-header>
      <a-layout-content style="background: #fff;" :style="{ padding: '10px' }">
        <router-view/>
      </a-layout-content>
    </a-layout>

    <a-modal title="Cambiar Contraseña"
             :visible="cc.visible"
             @ok="confirmarCambiarPassword"
             :confirmLoading="cc.modalCambiarPassLoading"
             @cancel="cancelarCambiarPassword">
      <a-form :form="frmCambiarPass" @submit="confirmarCambiarPassword">
        <a-form-item label="Nueva Clave" v-bind="fiOptions">
          <a-input type="password"
                   placeholder="Nueva Clave"
                   v-decorator="['nueva_clave', { rules: [
                                                       { required: true, message: 'Valor requerido' },
                                                       { type: 'string', validator: validatePasswordStatus }
                                                       ] }]">
          </a-input>
        </a-form-item>
        <a-form-item label="Repita la Contraseña" v-bind="fiOptions">
          <a-input type="password"
                   placeholder="Repita la Contraseña"
                   v-decorator="['repita_password', { rules: [
                                                      { required: true, message: 'Valor requerido'},
                                                      { required: true, validator: validatePassword, message: 'Las contraseñas no coinciden' }
                                                      ] }]">
          </a-input>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
  import UserUtil from '@/util/UserUtil'
  import HttpUtil from '@/util/HttpUtil'
  import JsUtils from '@/util/JsUtils'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  require('./assets/megamenu/css/style.css')

  export default {
    data () {
      return {
        profileSrc: require('./assets/profile_h.jpg'),
        frmCambiarPass: this.$form.createForm(this, {
          name: 'cambiarPassword',
          onFieldsChange: (_, changedFields) => {
            this.formularioActualizado(changedFields)
          }
        }),
        fiOptions: {
          'label-col': {span: 10},
          'wrapper-col': {span: 14},
          'has-feedback': true
        },
        cc: {
          visible: false,
          modalCambiarPassLoading: false
        }
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
      this.loadProfilePicture()
      require('./assets/megamenu/js/megamenu')
      window.megamenu.init()
    },
    computed: {
      userInfo () {
        return this.$store.state.userInfo ? this.$store.state.userInfo : {}
      },
      defaultSelectedKeys () {
        let defaultSelectedKeys = []
        let menu = this.userInfo.menu || []
        menu.forEach((menu) => {
          if (menu.path === null) {
            menu.children.forEach((child) => {
              if (child.path === this.$route.path) {
                defaultSelectedKeys.push(child.path)
              }
            })
          } else if (menu.path === this.$route.path) {
            defaultSelectedKeys.push(menu.path)
          }
        })
        return defaultSelectedKeys
      },
      headerBg () {
        let normal = this.$store.state.appSettings.customDashboardBg ? this.$store.state.appSettings.customDashboardBg : 'linear-gradient(to right, #093637, #44A08D) !important'
        return {
          background: normal
        }
      },
      logoBg () {
        let normal = this.$store.state.appSettings.customLogoBg ? this.$store.state.appSettings.customLogoBg : '#093637 !important'

        return {
          background: normal
        }
      }
    },
    methods: {
      logout: function () {
        let respuesta = () => {
          this.$router.push({
            name: 'Login'
          })
        }
        UserUtil.logout(respuesta, respuesta)
      },
      logoutWithOkta: function () {
        // Eliminar los tokens y session_key del almacenamiento
        // sessionStorage.removeItem('session_key')
        // sessionStorage.removeItem('access_token')

        // Obtener el session_key almacenado
        const sessionKey = sessionStorage.getItem('session_key')

        let respuesta = () => {
          this.$router.push({
            name: 'Login'
          })
        }
        UserUtil.logoutWithOkta(respuesta, respuesta)

        this.httpClient.getInstance().get('get_id_token', {
          params: {
            session_key: sessionKey
          }
        })
          .then(response => {
            const idToken = response.data.id_token

            // Si obtuvimos el id_token, redirigir al endpoint de logout de Okta
            if (idToken) {
              const postLogoutRedirectUri = 'https://pluxee.rhselfservice.com' // URL donde redirigir después del logout
              window.location.href = `https://identity.pluxee.app/oauth2/v1/logout?id_token_hint=${idToken}&post_logout_redirect_uri=${postLogoutRedirectUri}`
            } else {
              // Si no obtenemos el id_token, redirigir a la página de login directamente
              window.location.href = 'https://pluxee.rhselfservice.com'
            }
          })
          .catch(() => {
            // Si hay error, redirigir al login directamente
            window.location.href = 'https://pluxee.rhselfservice.com'
          })
      },
      navigate (menu) {
        if (JsUtils.isEmpty(menu.path)) return
        if (this.$route.path !== menu.path) {
          this.$router.push({path: menu.path})
        }
      },
      loadProfilePicture () {
        this.httpClient.getInstance().get('picture_service/render/profile', {
          responseType: 'arraybuffer'
        })
          .then((response) => {
            let blob = new Blob([response.data], {type: response.headers['content-type']})
            this.profileSrc = window.URL.createObjectURL(blob)
          })
          .catch(() => {
            // no nos interesa
          })
      },
      validatePasswordStatus (rule, value, callbackfn) {
        if (value.length < 8 || value.length > 12) {
          callbackfn('Debe tener entre 8 y 12 carácteres.')
          return false
        }

        /* debe tener una mayus */
        let contieneMayus = (/[A-Z]/.test(value))
        /* deebe terer una minus */
        let contieneMinus = (/[a-z]/.test(value))
        /* debe tener por lo menos un numero */
        let contieneNum = (/[0-9]/.test(value))

        if (!contieneMayus || !contieneMinus || !contieneNum) {
          callbackfn('Debe tener por lo menos una minuscula, una mayuscula y un número.')
        }
        callbackfn()
      },
      validatePassword (rule, value, callbackfn) {
        if (value === this.password) {
          callbackfn()
        }
        callbackfn('Error')
      },
      formularioActualizado (values) {
        this.password = this.frmCambiarPass.getFieldValue('nueva_clave')
      },
      confirmarCambiarPassword (e) {
        e && e.preventDefault()
        this.frmCambiarPass.validateFields(async (err, values) => {
          if (!err) {
            this.cc.modalCambiarPassLoading = true
            let gtoken = ''
            if (this.$store.state.appSettings.recaptcha.enabled) {
              await this.$recaptchaLoaded()
              // Execute reCAPTCHA with action "login".
              gtoken = await this.$recaptcha('reset_password')
            }

            this.httpClient.getInstance()
              .post('password_recovery/update_user_password', {
                ...values,
                gtoken
              })
              .then((response) => {
                if (parseInt(response.data.resultado) === 2) {
                  Mensajes.success('Correcto', 'Contraseña actualizada correctamente')
                  this.cc.visible = false
                } else {
                  Mensajes.error('Error', response.data.mensaje)
                }
                this.cc.modalCambiarPassLoading = false
              })
              .catch(() => {
                Mensajes.error('Error', 'No fue posible realizar la solicitud.')
                this.cc.modalCambiarPassLoading = false
              })
          }
        })
      },
      cancelarCambiarPassword () {
        if (this.cc.modalCambiarPassLoading) return
        this.cc.visible = false
        this.cc.modalCambiarPassLoading = false
      }
    }
  }
</script>
<style scoped>
  .logo {
    /* background: rgba(255, 255, 255, .2); */
    float: left;
  }

  .ant-layout-header {
    padding: 0 10px;
    /*margin-bottom: 10px;*/
    /*background-color: #1d83b3;*/
  }

  .ant-layout-sider-zero-width-trigger {
    top: 0;
  }

  .menuColor {
    color: white;
  }

  .logoBg {
    background: #093637 !important; /* fallback for old browsers */
  }

  .headerBg {
    /*background: #00b09b;  /* fallback for old browsers */
    /*background: -webkit-linear-gradient(to left, #96c93d, #00b09b);  /* Chrome 10-25, Safari 5.1-6 */
    /*background: linear-gradient(to left, #96c93d, #00b09b); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    background: #44A08D !important; /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #093637, #44A08D) !important; /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #093637, #44A08D) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  }

  .headerLogo {
    max-height: 43px;
    float: left;
    margin-top: 3px;
  }

  .menu-container {
    width: 100%;
    line-height: normal;
    background: transparent;
  }

  .menu {
    height: 46px;
  }

  .menu > ul {
    height: 46px;
  }

  .menu > ul > li a {
    text-decoration: none;
    padding: 12px 25px;
    display: block;
    height: 46px;
    color: white;
  }

  .menu > ul > li > ul > li a {
    color: black;
    padding: 0.2em 0;
    height: auto;
    font-size: 14px;
  }

  .menu > ul > li > ul {
    background: white;
    /* border: 1px solid black; */
    -webkit-box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.47);
    -moz-box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.47);
    box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.47);
  }

  .menu > ul > li {
    background: transparent;
  }

  .menu > ul > li > ul > li > ul > li {
    padding: 5px;
  }

  /* content generado con esta maravilla: https://yoksel.github.io/url-encoder/ */
  .menu-dropdown-icon:before {
    height: 46px;
    width: 46px;
    content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='64 64 896 896' data-icon='plus-square' width='1em' height='1em' fill='currentColor' aria-hidden='true' focusable='false' class=''%3E%3Cpath d='M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z'%3E%3C/path%3E%3Cpath d='M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'%3E%3C/path%3E%3C/svg%3E");
    padding: 16px;
    color: white;
    background: transparent;
  }

  @media only screen and (min-width: 959px) {
    .mainHeader {
      position: fixed;
    }

    .ant-layout-content {
      margin-top: 46px;
    }

    .optionsMenu {
      right: 0px;
      width: 190px !important;
    }

    .menu > ul > li:hover {
      background: rgba(255, 255, 255, .1) !important;
    }

    .menu > ul > li > ul > li > ul > li:hover {
      background: rgba(0, 0, 0, .1) !important;
    }
  }

  @media only screen and (max-width: 959px) {
    .ant-layout-content {
      margin-top: 10px;
    }

    .menu {
      height: 59px;
    }

    .menu > ul > li {
      border-bottom: 1px solid gray;
      background: white;
      color: black;
    }

    .menu > ul > li a {
      color: black;
    }

    .menu-mobile:after {
      content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='64 64 896 896' data-icon='menu' width='32px' height='32px' fill='white' aria-hidden='true' focusable='false' class=''%3E%3Cpath d='M904 160H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0 624H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0-312H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z'%3E%3C/path%3E%3C/svg%3E");
      color: white;
      height: 46px;
      width: 46px;
      padding-left: 46px;
      background: transparent;
    }

    .headerLogo {
      margin-top: 12px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/Main.vue